import { graphql, useStaticQuery } from "gatsby";
import BackgroundImage from "gatsby-background-image";
import { Brand } from "~/components/domain/Brand";
import { Concept } from "~/components/domain/Concept";
import { Footer } from "~/components/domain/Footer";
import { Hero } from "~/components/domain/Hero";
import { Container } from "~/components/layout/Container";
import { BlurredBackground } from "~/components/shared/BlurredBackground";
import { LogoVideo } from "~/components/shared/LogoVideo";
import * as styles from "./styles";
import { ScrollAnimation } from "~/components/shared/ScrollAnimation";
import { Gallery } from "~/components/domain/Gallery";
import { useRef, useState } from "react";
import { IconTriangleHorizontalFilled } from "~/components/shared/icons/IconTriangleHorizontalFilled";

export const Index = () => {
  const { background } = useStaticQuery<GatsbyTypes.BrandQuery>(
    graphql`
      query Brand {
        background: file(relativePath: { eq: "bg-okaeri.png" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );

  const backgroundVideoRef = useRef<HTMLVideoElement>(null);
  const heroVideoRef = useRef<HTMLVideoElement>(null);

  const [isBackgroundVideoEnded, setBackgroundVideoEnded] =
    useState<boolean>(false);
  const [isHeroVideoEnded, setHeroVideoEnded] = useState<boolean>(false);

  const backgroundVideoEnded = () => {
    setBackgroundVideoEnded(true);
  };

  const heroVideoEnded = () => {
    setHeroVideoEnded(true);
  };

  // 動画の同期再生
  const handleReplayVideo = () => {
    if (backgroundVideoRef.current && heroVideoRef.current) {
      backgroundVideoRef.current.play();
      heroVideoRef.current.play();
      setBackgroundVideoEnded(false);
      setHeroVideoEnded(false);
    }
  };

  return (
    <div css={styles.page}>
      <BlurredBackground
        background={
          <LogoVideo
            forwardRef={backgroundVideoRef}
            onEnded={backgroundVideoEnded}
          />
        }
      >
        <Hero>
          <LogoVideo forwardRef={heroVideoRef} onEnded={heroVideoEnded} />
          <Container css={styles.heroContainer}>
            {isBackgroundVideoEnded && isHeroVideoEnded && (
              <button css={styles.replayButton} onClick={handleReplayVideo}>
                <IconTriangleHorizontalFilled css={styles.replayIcon} />
                もう一度再生する
              </button>
            )}
          </Container>
        </Hero>
      </BlurredBackground>

      <BackgroundImage
        fluid={background?.childImageSharp?.fluid}
        style={{ backgroundPosition: "center", backgroundSize: "cover" }}
      >
        <Container css={styles.brandContainer}>
          <ScrollAnimation>
            <Brand />
          </ScrollAnimation>
        </Container>
      </BackgroundImage>

      <Container>
        <Concept />
      </Container>

      <div css={styles.galleryBackground}>
        <Container>
          <Gallery />
        </Container>
      </div>
      <div css={styles.FooterBackground}>
        <BackgroundImage
          fluid={background?.childImageSharp?.fluid}
          css={styles.footerBackgroundImage}
        >
          <Container>
            <Footer />
          </Container>
        </BackgroundImage>
      </div>
    </div>
  );
};
